<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : packMark.pkid > 0 ? '编辑' : '新建'"
      width="1200px"
      top="10px"
      class="packMarkEdit"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="packMark"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <div class="editTitle">基本信息</div>
      <el-row>
        <el-col :span="12">
          <el-form-item label="装箱单号" prop="packNo">
            <el-input v-model="packMark.packNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="总数" prop="qty">
            <el-input v-model="packMark.qty" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="内装数量" prop="singleQty">
            <el-input v-model="packMark.singleQty"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="客户" prop="customerName">
            <el-input v-model="packMark.customerName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发货联系人" prop="deliveryContact">
            <el-input v-model="packMark.deliveryContact"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发货联系方式" prop="deliveryTel">
            <el-input v-model="packMark.deliveryTel"/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="发货地址" prop="deliveryAddress">
            <el-input v-model="packMark.deliveryAddress"/>
          </el-form-item>
        </el-col>
        <el-col v-if="packMark.pkid > 0" :span="12">
          <el-form-item label="制单日期" prop="createTime">
            <el-input v-model="packMark.createTime" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="packMark.pkid > 0" :span="12">
          <el-form-item label="制单人" prop="creatorName">
            <el-input v-model="packMark.creatorName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="note">
            <el-input v-model="packMark.note" type="textarea" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle" style="margin-top: 10px">明细</div>
      <el-table
          class="tableBox"
          :data="packMark.orderVOS"
          border
          stripe
          height="40vh">
        <el-table-column prop="orderNo" align="left" label="订单编号" width="140"/>
        <el-table-column prop="rowIndex" align="left" label="订单行号" width="100"/>
        <el-table-column prop="materialNo" align="left" label="物料编号" width="140"/>
        <el-table-column prop="materialName" align="left" label="物料名称" width="120"/>
        <el-table-column prop="specification" align="center" label="规格型号"/>
        <el-table-column prop="orderQty" align="center" label="源单据数量" width="100"/>
        <el-table-column prop="packQty" align="center" label="装箱数量" width="100">
          <template slot-scope="scope">
            <el-input v-model="scope.row.packQty"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80px" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" @click="deleteMaterial(scope.$index)"> 删除 </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  name: "PackMarkEdit",
  data() {
    return {
      disabled: false,
      dialogVisible: false,
      submitLoading: false,
      contentLoading: false,
      index: 0,
      packMark: {
        pkid: 0,
        packNo: "",
        singleQty: "",
        qty: "",
        CaseNo: "",
        CaseQty:"",
        relBillId: "",
        requireDate: "",
        status: "",
        statusName: "",
        creatorName: "",
        createTime: "",
        note: "",
        detailVOS: [],
        orderVOS: [],
      },
      ruleValidate: {
        quantity: {required: true, trigger: "blur"},
        relBillNo: {required: true, message: "请选择关联单号", trigger: "change"},
      },
    };
  },
  methods: {
    open(id, orderIds, type, disabled) {
      this.dialogVisible = true;
      if (id > 0) {
        this.packMark.pkid = id;
        this.getData();
      } else {
        this.initData(orderIds, type);
      }
      if (disabled) {
        this.disabled = true;
      }
    },

    initData(orderIds, type) {
      this.contentLoading = true;
      this.$http
          .get("basic", `packMarks/initVo/${orderIds}/${type}`)
          .then((resp) => {
            if (resp.success) {
              this.packMark = Object.assign(this.packMark, resp.data);
              this.contentLoading = false;
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
    },
    // 删除物料
    deleteMaterial(index) {
      this.packMark.orderVOS.splice(index, 1);
    },

    // 根据出货订单id查询详细信息
    getData() {
      this.contentLoading = true;
      this.$http
          .get("basic", `packMarks/${this.packMark.pkid}`)
          .then((resp) => {
            if (resp.success) {
              this.packMark = Object.assign(this.packMark, resp.data);
              this.contentLoading = false;
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
    },

    setIndex(index) {
      this.index = index;
    },

    FLlocationSelect(row) {
      console.log(this.packMark);
      this.packMark.detailVOS[this.index].locationName = row.warehouseLocationName;
      this.packMark.detailVOS[this.index].locationId = row.pkId;
      this.packMark.detailVOS[this.index].locationNo = row.warehouseLocationNo;
      this.packMark.detailVOS[this.index].warehouseAreaName = row.warehouseAreaName;
      this.packMark.detailVOS[this.index].warehouseAreaNo = row.warehouseAreaNo;
      console.log(this.packMark.detailVOS);
    },

    deleteRow(row, index) {
      this.packMark.detailVOS.splice(index, 1);
    },

    //选择关联单号
    deliveryNoticeSelect(rows) {
      if (rows) {
        let custId = rows[0].customerId;
        rows.forEach(item => {
          if (custId !== item.customerId) {
            this.$confirm("请选择相同客户发货通知单", "错误", {
              type: "error",
              showCancelButton: false,
            });
            return;
          }
        });
        if (this.packMark.pkid === 0) {
          this.packMark.customerId = custId;
          this.packMark.customerNo = rows[0].customerNo;
          this.packMark.customerOutNo = rows[0].customerOutNo;
          this.packMark.customerName = rows[0].customerName;
          this.packMark.customerOuterNo = rows[0].customerOuterNo;
          this.packMark.erpSalType = rows[0].erpSalType;
          this.packMark.erpWorkShop = rows[0].erpWorkShop;
          this.packMark.RequireDate = rows[0].deliveryDate;
          this.packMark.deliveryContact = rows[0].deliveryContact;
          this.packMark.deliveryTel = rows[0].deliveryTel;
          this.packMark.deliveryAddress = rows[0].deliveryAddress;
        }

        rows.forEach(item => {
          if (item.quantity > item.deliveryQuantity) {
            let data = {
              materialNo: item.materialNo,
              materialName: item.materialName,
              specification: item.specification,
              quantity: item.quantity - item.deliveryQuantity,
              deliveryDate: item.requireDeliveryDate,
              note: item.note,
              refBillId: item.masterId,
              refBillNo: item.billNo,
              refRowIndex: item.rowIndex,
              rowIndex: this.rowIndex++,
              locationName: item.locationName,
              locationId: item.locationId,
              warehouseAreaNo: item.warehouseAreaNo,
              warehouseAreaName: item.warehouseAreaName,
            };
            this.packMark.detailVOS.push(data);
          }
        });
      }
    },

    getDetailData(id) {
      this.$http.get("basic", `outStockDeliverys/getDetailByTask/${id}`).then((res) => {
        if (res.success) {
          this.packMark.detailVOS = res.data;
        }
      });
    },
    // 编辑、新建
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.packMark.orderVOS.length) {
            this.$confirm("明细不能为空", "错误", {
              type: "error",
              showCancelButton: false,
            });
            return;
          }

          this.submitLoading = true;
          this.$http
            .save("basic", "packMarks", this.packMark)
            .then((resp) => {
              this.submitLoading = false;
              if (resp.success) {
                if (this.packMark.pkid > 0) {
                  this.$emit("save-success");
                  this.$message.success("编辑成功");
                } else {
                  this.$emit("save-success");
                  this.$message.success("添加成功");
                }
                this.dialogVisible = false;
              }
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      });
    },

  },
};
</script>

<style lang="scss" scoped>
.packMarkEdit .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}

.packMarkEdit .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.packMarkEdit .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.packMarkEdit .el-divider--horizontal {
  margin: 10px 0;
}

.packMarkEdit .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}

.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding-bottom: 5px;
}

.tableBox .el-form-item__content {
  margin-left: 0 !important;
}

.tableBox .el-form-item {
  margin-bottom: 0;
}

.tableBox .el-input--mini .el-input__inner {
  text-align: center;
}
</style>
